'use client';
import { ICartItem } from '@/api/types/cart';
import WapOnly from '@/components/Responsive/WapOnly';
import WebOnly from '@/components/Responsive/WebOnly';

// 导入子组件和hooks
import { useCartItem } from '../hooks/useCartItem';
import { InvalidCartItemPC } from './InvalidCartItem.pc';
import { InvalidCartItemMobile } from './InvalidCartItem.m';
import CartItemDialog from '../cartItemComponents/CartItemDialog';

// 类型定义
interface InvalidCartItemProps {
  cartItemData: ICartItem;
  batchFlag: boolean;
  onReload: (cartData?: any) => void;
  itemIndex?: number;
  onCartPrescriptionEditBtnClick?: (btnName: string, cartItemData: ICartItem) => void;
  // 可选的参数，用于兼容useCartItem hook
  currency?: any;
  // 不可结算商品选中状态变化回调
  selected?: boolean;
  onInvalidSelectChange?: (checked: boolean) => void;
}

export function InvalidCartItem(props: InvalidCartItemProps) {
  // 使用可结算购物车的hooks，不可结算功能是其子集
  const cartItemHooks = useCartItem({
    cartItemData: props.cartItemData,
    batchFlag: props.batchFlag,
    onReload: props.onReload,
    selected: props.selected || false, // 不可结算商品的选中状态
    onSelectChange: undefined, // 不使用普通的选择逻辑
    onInvalidSelectChange: props.onInvalidSelectChange, // 使用不可结算商品的选择逻辑
    currency: props.currency,
    itemType: props.cartItemData.type || 1,
  });

  // 根据设备类型渲染不同版本
  return (
    <div className="invalid-cart-item">
      {/* PC端版本 */}
      <WebOnly>
        <InvalidCartItemPC {...props} {...cartItemHooks} selected={props.selected} />
      </WebOnly>

      {/* 移动端版本 */}
      <WapOnly>
        <InvalidCartItemMobile {...props} {...cartItemHooks} selected={props.selected} />
      </WapOnly>

      {/* 购物车项目确认对话框 */}
      <CartItemDialog
        open={cartItemHooks.showCartItemDialog}
        onClose={() => cartItemHooks.setShowCartItemDialog(false)}
        content={cartItemHooks.cartItemDialogProps.content}
        content2={cartItemHooks.cartItemDialogProps.content2}
        content2TextAlignCenter={cartItemHooks.cartItemDialogProps.content2TextAlignCenter}
        confirmText={cartItemHooks.cartItemDialogProps.confirmText}
        cancelText={cartItemHooks.cartItemDialogProps.cancelText}
        removeLens={cartItemHooks.cartItemDialogProps.removeLens}
        onConfirm={cartItemHooks.cartItemDialogProps.onConfirm}
        onRemoveLens={cartItemHooks.cartItemDialogProps.onRemoveLens}
      />
    </div>
  );
}

export default InvalidCartItem;
